/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'restaurant': {
    width: 110,
    height: 98,
    viewBox: '0 0 110 98',
    data: '<path pid="0" d="M15.889 0L0 25.79v6.446c0 6.428 4.908 11.606 11 11.606s11-5.178 11-11.606c0 6.428 4.908 11.606 11 11.606s11-5.178 11-11.606c0 6.428 4.908 11.606 11 11.606s11-5.178 11-11.606c0 6.428 4.908 11.606 11 11.606s11-5.178 11-11.606c0 6.428 4.908 11.606 11 11.606s11-5.178 11-11.606V25.79L94.111 0H15.89zM22 39.893c-2.411 3.823-6.335 6.528-11 6.528-.835 0-1.652-.085-2.444-.242V98h92.888V46.18c-.792.156-1.609.241-2.444.241-4.665 0-8.589-2.705-11-6.528-2.411 3.823-6.335 6.528-11 6.528s-8.589-2.705-11-6.528c-2.411 3.823-6.336 6.528-11 6.528s-8.589-2.705-11-6.528c-2.411 3.823-6.336 6.528-11 6.528-4.665 0-8.589-2.705-11-6.528zm1.222 11.686h24.445v36.105H23.222V51.579zm36.667 0h26.889V69.63h-26.89V51.58z" _fill="#2B363B"/>'
  }
})
